module.exports = __webpack_public_path__ + "img/banner.45d7eab0.svg";